export default __webpack_public_path__ + "static/media/react.ce38d6de.png";